define('lib/Four',['lib/Frame'], function (Frame) {

    "use strict";

    var drawFour = function(ctx, x, y, width) {
        // calculate how much to scale
        var scale = width / 192;

        // canvas transforms
        ctx.translate(x, y);
        ctx.scale(scale, scale);

        // draw path
        ctx.beginPath();
        ctx.moveTo(105.0839844,202.6582031);
        ctx.lineTo(0.0131836,202.6582031);
        ctx.lineTo(0.0131836,153.30126950000002);
        ctx.lineTo(104.3369141,-0.0048828);
        ctx.lineTo(159.3027344,-0.0048828);
        ctx.lineTo(159.3027344,160.77978520000002);
        ctx.lineTo(195.19824219999998,160.77978520000002);
        ctx.lineTo(195.19824219999998,202.65820320000003);
        ctx.lineTo(159.3027344,202.65820320000003);
        ctx.lineTo(159.3027344,258.74609380000004);
        ctx.lineTo(105.08398439999999,258.74609380000004);
        ctx.lineTo(105.08398439999999,202.6582031);
        ctx.closePath();
        ctx.moveTo(105.0839844,69.1694336);
        ctx.lineTo(104.3369141,69.1694336);
        ctx.lineTo(42.2661133,160.7797852);
        ctx.lineTo(105.08398439999999,160.7797852);
        ctx.lineTo(105.08398439999999,69.1694336);
        ctx.closePath();

        // manually restore transformation
        ctx.scale(1/scale, 1/scale);
        ctx.translate(-x, -y);
    };

    var containScale = function (aspectRatio, parentDimen) {
        var parentAR = parentDimen.height / parentDimen.width;

        if (parentAR > aspectRatio) {
            return parentDimen.width;
        } else {
            return parentDimen.height / aspectRatio;
        }
    };

    var coverScale = function (aspectRatio, parentDimen) {
        var parentAR = parentDimen.height / parentDimen.width;

        if (parentAR > aspectRatio) {
            return parentDimen.height / aspectRatio;
        } else {
            return parentDimen.width;
        }
    };

    /*
    var lineCenterAt = function (ctx, cx, cy, rotate, length) {
        // canvas transform
        ctx.translate(cx, cy);
        ctx.rotate(rotate);

        ctx.moveTo(0, -length/2);
        ctx.lineTo(0, length/2);

        // restore transform
        ctx.rotate(-rotate);
        ctx.translate(-cx, -cy);
    };
    */
   
    var xIntercept = function (x, y, slope, xAxis) {
        xAxis = xAxis || 0;
        return (xAxis - y)/slope + x;
    };

    var Four = function (canvas, bgImgURL, tDiff) {
        this.defer = $.Deferred();

        var bgImg = this.bgImg = new Image(),
            bgOnload = function () {
                this.start(canvas, false);
                this.defer.resolve();
            };

        bgImg.onload = bgOnload.bind(this);
        bgImg.src = bgImgURL;
        this.tDiff = tDiff || 0;
    };

    Four.prototype = new Frame();

    Four.prototype.resize = function () {
        var ar = 1.35,
            w = containScale(ar, this),
            h = w * ar,
            x = (this.width - w) / 2, // center on x-axis
            y = (this.height - h) / 2, // y-axis
            bgAr = this.bgImg.height/this.bgImg.width,
            bgW = coverScale(bgAr, this),
            bgH = bgW * bgAr,
            bgX = (this.width - bgW) / 2,
            bgY = (this.height - bgH) * 0.25;

        this.shapes = [
            {
                four: {
                    w: Math.round(w),
                    h: Math.round(h),
                    x: Math.round(x),
                    y: Math.round(y)
                },
                bg: {
                    w: Math.round(bgW),
                    h: Math.round(bgH),
                    x: Math.round(bgX),
                    y: Math.round(bgY)
                },
                lineLength: Math.max(this.width, this.height)*2
            }
        ];
    };

    /**
     * X intercepts of divide line with canvas top and bottom boundaries
     * @type {Object}
     */
    Four.prototype.divideLine = {
        top: 0,
        bottom: 0
    };

    Four.prototype.draw = function (shape, progress) {
        var ctx = this.ctx,
            divideAngle = 0.589,
            divideSlope = -1.4679,
            lineCX = shape.four.x + (shape.four.w * progress),
            lineCY = shape.four.y + (shape.four.h * progress);
        
        // invert background
        ctx.save();
        drawFour(this.ctx, shape.four.x, shape.four.y, shape.four.w);
        ctx.clip();
        ctx.drawImage(this.bgImg, shape.bg.x, shape.bg.y, shape.bg.w, shape.bg.h);
        ctx.restore();

        // cut invert background
        ctx.save();
        ctx.translate(lineCX, lineCY);
        ctx.rotate(divideAngle - (Math.PI/2));
        ctx.clearRect(-this.width/2, 0, this.width, this.height * 2);
        ctx.restore();
       
        // lines style
        ctx.lineWidth = 3;
        ctx.strokeStyle = '#999';

        // divide line
        this.divideLine = {
            top: xIntercept(lineCX, lineCY, divideSlope),
            bottom: xIntercept(lineCX, lineCY, divideSlope, this.height)
        };

        ctx.moveTo(this.divideLine.top, 0);
        ctx.lineTo(this.divideLine.bottom, this.height);
        ctx.stroke();

        // four outline
        drawFour(this.ctx, shape.four.x, shape.four.y, shape.four.w);
        ctx.stroke();
    };

    return Four;

});
